import { useState } from 'react';
import { toast } from 'react-toastify';

import DownloadIcon from '../../../assets/svg/DownloadIcon';
import { downloadFile } from '../../../helpers';
import { AudioPlayer } from '../../ConversionLab';
import { BasicModal, Button } from '../../Shared';

export const ListenRecordingModal = ({ open, onClose, recording }) => {
  const [isRecordLoading, setIsRecordLoading] = useState(false);

  const downloadRecording = async () => {
    setIsRecordLoading(true);

    try {
      const response = await fetch(recording.recordingURL);

      if (response.status !== 200) throw new Error();

      const blob = await response.blob();
      downloadFile(blob, 'recording.mp3');
      setIsRecordLoading(false);
    } catch {
      setIsRecordLoading(false);
      toast.error('Something went wrong, please try again!', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  return (
    <BasicModal open={open} onClose={isRecordLoading ? undefined : onClose}>
      <div className="bg-white w-[576px] rounded-2xl shadow-[-40px_40px_80px_-8px_rgba(0,0,0,0.24)]">
        <div className="flex items-center justify-between py-4 pl-5 pr-4 border-b border-b-base-200">
          <span className="text-base-1000 font-semibold text-[22px]/[28px]">
            Listen Recording
          </span>
          <button
            type="button"
            className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-transparent text-sm font-semibold text-gray-800 transition hover:bg-gray-100 disabled:pointer-events-none disabled:opacity-50 dark:text-white dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
            data-hs-overlay="#edit-contact-modal"
            onClick={onClose}
            disabled={isRecordLoading}
          >
            <span className="sr-only">Close</span>
            <svg
              className="h-4 w-4 flex-shrink-0"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>
        <div className="flex flex-col gap-4 py-4 px-5">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1">
              <svg
                data-slot="icon"
                fill="none"
                strokeWidth="1.5"
                stroke="#0f0f74"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z"
                ></path>
              </svg>
              <span className="text-brand-900 font-semibold">
                {recording.contactName}
              </span>
            </div>
            <span className="text-brand-900 font-semibold">
              {recording.date}
            </span>
          </div>
          <AudioPlayer src={recording.recordingURL} />
        </div>
        <div className="flex items-center justify-end gap-3 py-4 px-5 border-t border-t-base-200">
          <Button
            title="Cancel"
            variant="blue"
            onClick={onClose}
            disabled={isRecordLoading}
          />
          <Button
            title="Download"
            iconStart={<DownloadIcon className="w-5 h-5 text-white" />}
            disabled={isRecordLoading}
            onClick={downloadRecording}
          />
        </div>
      </div>
    </BasicModal>
  );
};
